import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './style.module.less';
const ShortcutItem = ({ label, keys, className }) => (_jsxs("div", { className: clsx(styles.shortcut, className), children: [_jsx("p", { className: styles.shortcutLabel, children: label }), _jsx("div", { className: styles.shortcutKeys, children: keys.map((key, index) => (
            /* eslint-disable-next-line react/no-array-index-key */
            _jsxs("div", { children: [index > 0 ? _jsx("span", { className: styles.shortcutPlus, children: "+" }) : null, _jsx("span", { className: styles.shortcutKey, children: key })] }, index))) })] }));
export default ShortcutItem;
